import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/ListModeApi'
import store from '../Search/store'
import { message, Modal } from 'hljd'
import moment from 'moment'

class Store {
  @observable loading = false
  @observable
  params = {
    date: undefined,
    venue: '0',
    meal: [],
    userName: '',
    phone: ''
  }
  @observable
  modal = {
    title: '',
    visible: false,
    uid: '',
    buttonText: ''
  }
  //新建
  @action
  addSchedule = () => {
    Object.assign(this.modal, {
      title: '新建档期',
      visible: true,
      buttonText: '新建'
    })
  }
  //修改
  @action
  updateSchedule = (id, entity_id, date, phone, user_name, time_str) => () => {
    let arrTmp = time_str.split(',')
    let arr = []
    arrTmp.forEach(item => {
      if (item == '1' || item == '2') {
        arr.push(',' + item + ',')
      }
    })
    Object.assign(this.params, {
      date: moment(date, 'YYYY-MM-DD'),
      venue: entity_id,
      meal: arr,
      userName: user_name,
      phone: phone
    })

    Object.assign(this.modal, {
      title: '编辑档期',
      visible: true,
      uid: id,
      buttonText: '修改'
    })
  }

  //保存
  @action
  save = async () => {
    if (this.modal.title === '新建档期') {
      let params = this.getScheduleParams()
      this.loading = true
      let { data, RetCode } = await Api.createCalenderItem(params)
      runInAction(() => {
        if (RetCode == '500') {
          this.loading = false
        } else {
          this.clear()
          this.loading = false
          this.modal.visible = false
          store.getList()
          message.success(data.msg)
        }
      })
    } else {
      let params = this.getScheduleParams(this.modal.uid)
      let { data, RetCode } = await Api.updateCalenderItem(params)
      runInAction(() => {
        if (RetCode == '500') {
        } else {
          this.modal.visible = false
          Object.assign(this.modal, {
            uid: ''
          })
          store.getList()
          this.clear()
          message.success(data.msg)
        }
      })
    }
  }
  //取消
  @action
  cancel = () => {
    this.clear()
    Object.assign(this.modal, {
      visible: false,
      uid: ''
    })
  }
  //删除确认弹出框
  @action
  delModal = id => () => {
    Modal.confirm({
      title: '你确定删除该档期吗？',
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        this.delSchedule(id)
      }
    })
  }
  //删除档期
  delSchedule = async id => {
    const { success } = await Api.delCalenderItem({ id: Number(id) })
    if (success) {
      store.getList()
      message.success('操作成功')
    }
  }
  //清空表单
  @action
  clear() {
    this.params.date = undefined
    this.params.venue = '0'
    this.params.meal = []
    this.params.userName = ''
    this.params.phone = ''
  }
  getScheduleParams(id) {
    const { params } = this
    let time_str
    if (params.meal.length == 1) {
      time_str = params.meal.join('')
    } else {
      time_str = params.meal.join('').replace(',,', ',')
    }
    return {
      type: 3,
      date: params.date.format('YYYY-MM-DD'),
      entity_id: Number(params.venue),
      time_str,
      user_name: params.userName,
      phone: Number(params.phone),
      id
    }
  }
}
export default new Store()
